import React from 'react';

import Icon from '../icon2';

import './icon2__menu.scss';

export default function Icon2Menu(props) {
    return (
        <Icon height="12px" name="menu" viewBox="0 0 16 12" width="16px" {...props}>
            <g>
                <path d="m0 0h2v2h-2z" />
                <path d="m0 5h2v2h-2z" />
                <path d="m0 10h2v2h-2z" />
                <path d="m4 0h12v2h-12z" />
                <path d="m4 5h12v2h-12z" />
                <path d="m4 10h12v2h-12z" />
            </g>
        </Icon>
    );
}
/* eslint-enable max-len */
